import React, { createContext, useContext, useState, ReactNode } from 'react';

interface InitializationContextType {
  progress: number;
  isInitialized: boolean;
  setProgress: (progress: number) => void;
  setIsInitialized: (isInitialized: boolean) => void;
}

const InitializationContext = createContext<InitializationContextType | undefined>(undefined);

export const InitializationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [progress, setProgress] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);

  return (
    <InitializationContext.Provider value={{ progress, isInitialized, setProgress, setIsInitialized }}>
      {children}
    </InitializationContext.Provider>
  );
};

export const useInitialization = () => {
  const context = useContext(InitializationContext);
  if (context === undefined) {
    throw new Error('useInitialization must be used within an InitializationProvider');
  }
  return context;
}; 